module.exports = __webpack_public_path__ + "img/Netz.de3b8e6e.png";